export const TITLE = $.__('2-Step Login Backup Codes');
export const HEADLINE = $.__('Keep these codes safe, but accessible.');
export const ERROR_MESSAGE = $.__('Uh-oh. Something went wrong, please try this again later.');
